module.exports = __webpack_public_path__ + "img/logo-sm-transparent.5ffd6d14.png";